import React, { useEffect, useState } from "react";

declare global {
  interface Window {
    newCoach: any;
    ReactNativeWebView: any;
  }
}

function useDeviceInfo() {
  const [deviceInfo, setDeviceInfo] = useState({
    appToken: "",
    deviceOsCode: 0,
    deviceName: "",
    deviceMacId: "",
  });

  useEffect(() => {
    const deviceInfo = navigator.userAgent;
    if (deviceInfo.includes("Android") && !window.ReactNativeWebView) {
      const adAppToken = window.newCoach?.getAdAppToken() || "";
      const deviceOsCode = window.newCoach?.getDeviceOsCode() || 0;
      const deviceName = window.newCoach?.getDeviceName() || "";
      const deviceMacId = window.newCoach?.getDeviceMacId() || "";
      setDeviceInfo((previousValue) => ({
        ...previousValue,
        appToken: adAppToken,
        deviceOsCode: deviceOsCode,
        deviceName: deviceName,
        deviceMacId: deviceMacId,
      }));
    }

    // iOS RN
    window.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setDeviceInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 2,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    // AOS RN
    document.addEventListener("message", ({ data }: any) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setDeviceInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 1,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("getDeviceInfo");
    }
  }, []);

  return deviceInfo;
}

export default useDeviceInfo;
